import { makeStyles } from "tss-react/mui";
import { MiAvatar, MiMenu } from "@miplatform/components";
import { mdiAccountCircle, mdiFileDocumentOutline, mdiLogout } from "@mdi/js";
import { useTheme } from "@mui/material";
import { useUserMenuController } from "./useUserMenuController";

const useStyles = makeStyles()((theme) => ({
  avatar: {
    backgroundColor: theme.palette.green.main,
    height: 40,
    width: 40,
    fontSize: theme.fontSize.xlarge,
    cursor: "pointer",
    fontWeight: theme.fontWeight.regular,
  },
  menuItem: {
    "& .MuiTypography-root": {
      fontSize: theme.fontSize.large,
    },
  },
}));

export function UserMenu() {
  const { classes } = useStyles();
  const theme = useTheme();
  const { getUserInitials, navigateLegal, navigateProfile, handleLogout } =
    useUserMenuController();

  const isLocalEnv = process.env.BYPASS_AUTH;

  return (
    <MiMenu
      data={[
        {
          label: "Profile",
          icon: mdiAccountCircle,
          color: theme.palette.grey.medium,
          action: navigateProfile,
        },
        {
          label: "Legal",
          icon: mdiFileDocumentOutline,
          color: theme.palette.grey.medium,
          action: navigateLegal,
        },
        {
          label: "Logout",
          icon: mdiLogout,
          color: theme.palette.grey.medium,
          action: handleLogout,
          hide: isLocalEnv,
        },
        {
          label: "Switch User",
          icon: mdiLogout,
          color: theme.palette.grey.medium,
          action: navigateProfile,
          hide: !isLocalEnv,
        },
      ]}
      menuItemStyles={classes.menuItem}
      optionalElement={
        <MiAvatar className={classes.avatar} data-testid="profile-avatar">
          {getUserInitials()}
        </MiAvatar>
      }
      data-testid="profile-menu"
    />
  );
}
